import { render, staticRenderFns } from "./ResourceDetail.vue?vue&type=template&id=03c68089&scoped=true"
import script from "./ResourceDetail.vue?vue&type=script&lang=js"
export * from "./ResourceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c68089",
  null
  
)

export default component.exports